export default "/BoostOnly.glb";